var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"menu-item":"1"}},[_c('div',{staticClass:"dashboard-container"},[_c('dashboard-city-ranking',{staticClass:"element"}),_vm._v(" "),_c('post-score',{staticClass:"element"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b7af46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = null
// module chunks = 